<ng-template #globalAppclientTemplate let-valueinput="value">
  {{getAppClientLabel(valueinput)}}
</ng-template>

<app-crud-list [observabledata]="observabledata"
               [displayedColumns]="displayedcolumns"
               [postTreatmentCallback]="getPostTreatmentCallback()"
               [idColumnName]="'id'"
               [entityroot]="entityroot"
               [deleteEntityHandler]="deleteEntityHandler()"
               [removePostTreatmentHandler]="deletePostTreatmentHandler()"
               [listEditPathCallback]="getListEditPathCallback()"
               [specificColumnsTemplates]="[
                  {key: 'appclient', template: globalAppclientTemplate}
               ]">
</app-crud-list>
